import createConverter from './lib/create_converter';
import ActiveCall from 'models/active_call';

export default createConverter(ActiveCall);



// WEBPACK FOOTER //
// ./src/scripts/application/dto_converters/active_call_converter.js